import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useData } from "../lib/data";
import { SITE, TOOLS } from "../lib/util";
import { SearchForm } from "./Search";

const NAV = [["opskrifter/", "Opskrifter", "recipes"], ["opskrifter-med/", "Ingredienser", "ingredients"], ["koeleskabet/", "Køleskabet", "fridge"], ["guides/", "Guides", "guides"], ["vaerktoejer/", "Værktøjer", "tools"], ["madplan/", "Madplan", "plan"]];
const ACTIVE = { "opskrifter-med": "ingredients", opskrifter: "recipes", kategori: "recipes", guides: "guides", vaerktoejer: "tools", madplan: "plan", koeleskabet: "fridge" };

function Header() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [pathname]);
  const active = ACTIVE[pathname.split("/")[1]] || "";
  return (
    <header className={"hdr" + (open ? " open" : "")}>
      <div className="wrap in">
        <a className="brand" href="/" data-testid="brand-home-link"><i aria-hidden="true">🍳</i>{SITE}</a>
        <button className="burger" type="button" aria-expanded={String(open)} aria-controls="panel" onClick={() => setOpen(!open)} data-testid="burger-menu-button">Menu</button>
        <div className="panel" id="panel">
          <nav className="nav" aria-label="Hovedmenu">
            {NAV.map(([p, n, k]) => <a key={k} href={"/" + p} aria-current={k === active ? "page" : undefined} data-testid={`nav-${k}`}>{n}</a>)}
          </nav>
          <SearchForm />
        </div>
      </div>
    </header>
  );
}

function Footer() {
  const { categories, guides } = useData();
  return (
    <footer className="ftr"><div className="wrap"><div className="fcols">
      <div><h3>{SITE}</h3><p>Billige opskrifter, madplan og gratis værktøjer til hverdagens aftensmad.</p></div>
      <div><h3>Opskrifter</h3><ul>{categories.slice(0, 6).map(c => <li key={c.key}><a href={`/kategori/${c.key}/`}>{c.name}</a></li>)}</ul></div>
      <div><h3>Guides</h3><ul>{guides.slice(0, 5).map(g => <li key={g.slug}><a href={`/guides/${g.slug}/`}>{g.title}</a></li>)}</ul></div>
      <div><h3>Værktøjer</h3><ul>{TOOLS.map(t => <li key={t[0]}><a href={`/vaerktoejer/${t[0]}/`}>{t[1]}</a></li>)}<li><a href="/madplan/">Madplan</a></li><li><a href="/koeleskabet/">Køleskabet</a></li></ul></div>
    </div>
      <div className="fine">Priser pr. person er vejledende skøn og varierer med butik og sæson. <a href="/om/" data-testid="footer-om-link">Om os</a> <a href="/privatliv/" data-testid="footer-privatliv-link">Privatliv og cookies</a></div>
    </div></footer>
  );
}

export function Layout({ children }) {
  const data = useData();
  return (
    <>
      <a className="skip" href="#main">Gå til indhold</a>
      <Header />
      <main id="main">{data ? children : null}</main>
      {data && <Footer />}
    </>
  );
}
